const Play = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 21V3l16 9-16 9z" stroke="#000" strokeWidth="2" />
    </svg>
)

export default Play;